import { kuiperClassNames } from '@opallabs/kuiper'
import { ModularCarousel } from '../../../../../ModularCarousel'
import { DesktopSingle as TikTokDesktopSingle } from '../../../TikTokVideo/displays/DesktopSingle'
import { MAX_PHOTOS, SECTION_COMPONENT_NAME } from '../../constants'
import { DesktopSlide } from '../../slides/DesktopSlide'
import { DESKTOP, styles } from '../../styles'
import { DisplayProps } from '../../types'

const availableModules = [
  {
    component: DesktopSlide,
    componentName: SECTION_COMPONENT_NAME,
    title: '',
  },
]

// TikTok Video's desktop chrome with the carousel dropped into its asset pane.
// Desktop has no expanded grid; the mobile display owns that toggle.
export const DesktopSingle: React.FC<DisplayProps> = ({
  accountImage,
  accountName,
  content,
  isPresenting,
  isSnapshot,
  modules,
  onAddSection,
  onContentChange,
  onDeleteSection,
  onDragDrop,
  onExpandAsset,
  onRemoveAsset,
  onShowAssetPicker,
  onSoundChange,
  readOnly,
  sound,
  truncate,
  updateSectionPostOption,
}) => (
  <div
    css={styles.getDesktopBaseStyles(readOnly || isPresenting)}
    className={kuiperClassNames('tiktok tiktok-carousel tiktok-desktop-single')}
  >
    <TikTokDesktopSingle
      accountImage={accountImage}
      assetSlot={
        <div css={styles.desktopCarousel}>
          <ModularCarousel
            addComponentText="Add Photo"
            allProps={{ isSnapshot }}
            availableModules={availableModules}
            carouselWidth={DESKTOP.slideWidth}
            isExpanded={false}
            isPresenting={isPresenting}
            maxSections={MAX_PHOTOS}
            modules={modules}
            onAddSection={onAddSection}
            onDeleteSection={onDeleteSection}
            onDragDrop={onDragDrop}
            onExpandAsset={onExpandAsset}
            onRemoveAsset={onRemoveAsset}
            onShowAssetPicker={onShowAssetPicker}
            readOnly={readOnly}
            updateSectionPostOption={updateSectionPostOption}
          />
        </div>
      }
      content={content}
      isPresenting={isPresenting}
      isSnapshot={isSnapshot}
      onContentChange={onContentChange}
      onSoundChange={onSoundChange}
      readOnly={readOnly}
      sound={sound}
      truncate={truncate}
      username={accountName}
      video={null}
    />
  </div>
)
